// DialogYaTidak — dialog konfirmasi biner (Ya/Tidak) POLOS, generik untuk
// SELURUH app. SATU SUMBER (CLAUDE.md: "kalau butuh sesuatu di dua tempat,
// jadikan satu sumber") — jangan menyalin markup pop-up ya/tidak ini ke
// berkas lain lagi. Lahir dari kontrak B1 (InventoryPO.jsx): alur Simpan PO
// ("Apakah sudah yakin produk terinput dengan teliti?") dan alur Batal
// ("Apakah yakin ingin batal?" -> "Simpan sebagai draf?") tadinya akan jadi
// TIGA blok JSX hand-rolled yang isinya kembar persis kecuali teksnya — jadi
// dijadikan satu komponen dipakai 3x (atau lebih, lihat pemanggil lain).
//
// BUKAN pengganti dialog yang butuh ISIAN tambahan (mis. "Batalkan PO" yang
// mewajibkan teks alasan — lihat `DialogBatalPO` lokal di InventoryPO.jsx)
// ataupun `KonfirmasiPPN` (tetap dipertahankan apa adanya, isinya spesifik
// PPN) — keduanya di luar cakupan "ya/tidak polos" komponen ini.
import { useModalLayer } from "@/hooks/useModalGuard";

/**
 * @param {string} judul - pertanyaan konfirmasi, mis. "Apakah yakin ingin batal?"
 * @param {React.ReactNode} [children] - penjelasan tambahan opsional di bawah judul
 * @param {() => void} onTidak - jawaban "Tidak" (juga dipanggil saat klik backdrop)
 * @param {() => void} onYa - jawaban "Ya"
 * @param {boolean} [busy] - menonaktifkan kedua tombol + label tombol Ya jadi "Memproses..."
 * @param {string} [testid] - awalan data-testid; tombol jadi `${testid}-ya` / `${testid}-tidak`
 */
export default function DialogYaTidak({
  judul, children, onTidak, onYa, busy = false, testid = "dialog-ya-tidak",
  labelYa = "Ya", labelTidak = "Tidak",
}) {
  // Daftar sebagai lapisan modal PALING ATAS selama dialog ini terbuka —
  // supaya Escape/Ctrl+Enter yang ditujukan untuk dialog ini tidak ikut
  // memicu penjaga "isian belum disimpan" pada modal `useModalGuard` yang
  // masih ter-mount di baliknya (lihat "LAPISAN PALING ATAS YANG MENANG" di
  // hooks/useModalGuard.jsx). Komponen ini hanya pernah dirender selagi aktif
  // (pemanggil selalu memakai `{kondisi && <DialogYaTidak .../>}`), jadi
  // `useModalLayer(true)` di sini sudah cukup — tidak perlu prop `active`.
  useModalLayer(true);
  return (
    <div className="fixed inset-0 z-[60] bg-black/50 grid place-items-center p-4" onClick={onTidak}
         data-testid={testid}>
      <div onClick={(e) => e.stopPropagation()}
           className="bg-white rounded-2xl max-w-sm w-full shadow-2xl p-5 space-y-3">
        <h3 className="font-display font-bold text-base text-slate-900">{judul}</h3>
        {children && <div className="text-sm text-slate-600">{children}</div>}
        <div className="flex justify-end gap-2 pt-2">
          <button type="button" onClick={onTidak} disabled={busy} data-testid={`${testid}-tidak`}
                  className="h-10 px-4 rounded-lg border border-slate-200 text-sm text-slate-700 disabled:opacity-50">
            {labelTidak}
          </button>
          <button type="button" onClick={onYa} disabled={busy} data-testid={`${testid}-ya`}
                  className="h-10 px-4 rounded-lg bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-medium disabled:opacity-50">
            {busy ? "Memproses..." : labelYa}
          </button>
        </div>
      </div>
    </div>
  );
}
